



























































































































































































































import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import { deviceServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import mapMarkers1 from '@/views/deviceInfo/unit/mapMarkers1.vue';

@Component({
  components: { mapMarkers1 },
})
export default class DeviceInfoDetail extends Vue {
  @PropSync('flag', Number) pageFlag!: number; // 显示哪个页面flag
  @Prop(String) row!: string; // 传递给编辑页面的表单数据对象
  @Prop(String) helpType!: any; // 传递给编辑页面的表单数据对象
  antiShake = true; // 防抖判断
  showWhatFlag = true; // 展示哪个页面：编辑或新增
  private deviceGuid: any = ''; // 编辑接口用到得 设备主键
  // 表单数据对象
  formData: any = {
    name: '', // 岗位名称
    spaceName: undefined, // 空间名称
    sort: '', // 排序号
  };

  resultPosition: any = [
    {
      lat: '', // 纬度
      lng: '', // 经度
    },
  ];

  // 表单验证规则对象
  formRules: object = {
    name: [{ required: true, trigger: 'change', message: '必填信息' }],
    spaceName: [{ required: true, trigger: 'change', message: '必填信息' }],
    sort: [{ required: true, trigger: 'change', validator: this.sortValidator }],
  };

  dialogVisible = false; // 控制 dialog 是否显示
  dialogTitle = ''; // dialog 的标题
  checkNode: any = null; // 选中的节点数据
  // 树节点数据
  treeData: any[] = [];
  // dialog 中树形图的属性
  defaultProps: object = {
    children: 'children',
    label: 'name',
  };

  /**
   * @todo 后期需要优化的部分
   * @desc Vue数据加载生命周期函数
   * @param1 无
   * @returns 无
   */
  async created() {
    // 获取到该行机构的名称,然后传递给下级机构
    await deviceServer
      .getDeviceInfoDetail(this.row)
      .then((res: any) => {
        if (res.code === '200') {
          this.formData = res.data;
          this.deviceGuid = res.data.deviceGuid;
          this.resultPosition = [
            {
              lat: res.data.expand.latitude, // 纬度
              lng: res.data.expand.longitude, // 经度
            },
          ];
        }
        // console.log(this.resultPosition);
      })
      .catch(() => {
        this.$message.error('获取数据失败,请稍后重试!');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 定义 表单  sort权重排序的验证规则
   * @param1 rule： 暂不清楚
   * @param2 value: input 中的值
   * @param3 callback: 回调
   * @returns 如果 value 是空的和number类型 就正常返回，否则报错
   */
  sortValidator(rule: any, value: any, callback: any) {
    if (value !== null && value.toString().length > 9) {
      return callback(new Error('正整数只能小于9位'));
    }
    if (value === '') {
      return callback(new Error('必填信息'));
    }
    if (value < 0) {
      return callback(new Error('请输入一个正整数'));
    }
    return typeof value === 'number' ? callback() : callback(new Error('请输入一个正整数'));
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 每次点击树节点都会触发的事件，获得当前点击的id
   * @param1 data: 被点击的节点数据对象
   * @returns 暂无
   */
  handleNodeClick(data: any) {
    // 取消被选中的 树节点。
    (this.$refs.dialogTreeRef as any).store._getAllNodes().forEach((item: any, i: number) => {
      if (item.data !== data) {
        (this.$refs.dialogTreeRef as any).getNode(item.data.id).isCurrent = false;
      }
    });
    this.checkNode = data; // 选中的节点数据
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 函数描述
   * @param state - 模板状态 1-开始状态 2-结束状态
   * @returns 返回值描述
   */
  close() {
    this.pageFlag = 1; // 跳转到index页面
  }

  /**
   * todo 点击保存经纬度的
   * */
  savePosition() {
    let flag: any = false;
    let flag1: any = false;
    const obj = {
      deviceGuid: this.deviceGuid,
      longitude: this.resultPosition[0].lng, // 经度
      latitude: this.resultPosition[0].lat, // 纬度
    };
    // 保存经纬度的接口
    deviceServer.devicePoint(obj).then((res: any) => {
      if (res.code === '200') {
        console.log(res, 101);
        // 经纬度保存成功
        flag = true;
      }
    });

    deviceServer.editDevice(this.deviceGuid, this.formData).then((res: any) => {
      if (res.code === '200') {
        console.log(res, 102);
        // 表单数据保存成功
        flag1 = true;
      }
    });

    console.log(flag, flag1);
    setTimeout(() => {
      if (flag === true || flag1 === true) {
        this.$message.success('编辑设备成功');
        this.close();
      } else {
        this.$message.error('网络错误，请稍后再试');
        this.close();
      }
    }, 500);
  }

  private openMap() {
    const refName = 'mapMarkers1';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(this.resultPosition);
  }

  getMapPoint(data: any) {
    // console.log(this.resultPosition);
    if (data.length > 0) {
      this.$set(this.resultPosition[0], 'lat', data[0].lat.toString());
      this.$set(this.resultPosition[0], 'lng', data[0].lng.toString());
    } else {
      this.resultPosition = [];
    }
  }
}
